// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"OrderModal_modalBody__Cvqyy","orderDetails":"OrderModal_orderDetails__2GPdO"};